import { render, staticRenderFns } from "./refused-customer.vue?vue&type=template&id=aada386c&scoped=true&"
import script from "./refused-customer.vue?vue&type=script&lang=js&"
export * from "./refused-customer.vue?vue&type=script&lang=js&"
import style0 from "./refused-customer.vue?vue&type=style&index=0&id=aada386c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aada386c",
  null
  
)

export default component.exports